var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.stylePanel,
      on: {
        dragover: function($event) {
          $event.preventDefault()
          return _vm.handleDragOver($event)
        }
      }
    },
    [
      _c(
        "CompassPanel",
        {
          ref: _vm.refPanel,
          attrs: {
            size: "large",
            title: _vm.getPanelTitle,
            icon: "obj-slsy-sent-email",
            enableShrink: ""
          },
          on: { toggled: _vm.toggleState, closed: _vm.closePanel },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isPanelMinimized,
                          expression: "!isPanelMinimized"
                        }
                      ],
                      staticClass: "email-panel__footer"
                    },
                    [
                      _vm.richTextEditor
                        ? _c("RichTextMenu", {
                            staticClass: "email-richtext-menu",
                            attrs: {
                              editorMenu: _vm.richTextEditor,
                              options: _vm.optionsRichText,
                              typeRichText: "email",
                              disabled: _vm.isPanelMinimized,
                              hash: _vm.hashPanel
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "actions",
                                  fn: function() {
                                    return [
                                      _vm.showCustomTemplates
                                        ? _c("EmailCustomTemplateToolbar", {
                                            attrs: {
                                              hashPanel: _vm.hashPanel,
                                              linkedId: _vm.linkedId,
                                              linkedType: _vm.linkedType,
                                              typePanel: "newPanel"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              347170353
                            )
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "email-panel__footer-container" },
                        [
                          _vm.showHint
                            ? _c("div", {
                                staticClass:
                                  "email-panel__ai-hint typographies-paragraph-small-regular",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t.__("richtext.ai.hint")
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "container-actions" },
                            [
                              _c("CompassButton", {
                                attrs: {
                                  label: _vm.$t.__("common.actions.delete"),
                                  type: "secondary"
                                },
                                on: { click: _vm.closePanel }
                              }),
                              _vm._v(" "),
                              _vm.isFeatureScheduleEmailEnabled
                                ? [
                                    _c(
                                      "CompassTooltip",
                                      {
                                        attrs: {
                                          disabled: _vm.canSendEmail,
                                          content: _vm.$t.__(
                                            "email.EmailPanel.error_reconnect_email_account"
                                          ),
                                          placement: "top-end"
                                        }
                                      },
                                      [
                                        _c("CompassSplitButton", {
                                          ref: "SplitSendButton",
                                          attrs: {
                                            label: _vm.$t.__(
                                              "common.actions.send"
                                            ),
                                            loading: _vm.isLoading,
                                            disabled: !_vm.canSendEmail
                                          },
                                          on: {
                                            clickOnLabel: _vm.onSendEmail,
                                            clickOnArrow: function($event) {
                                              _vm.showDropdown = !_vm.showDropdown
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "CompassDropdown",
                                      {
                                        attrs: {
                                          parentRef: "SplitSendButton",
                                          isVisible: _vm.showDropdown,
                                          placement: "top-end",
                                          dropdownClass:
                                            "email-panel__schedule-dropdown"
                                        },
                                        on: {
                                          onVisibilityChanged: function(
                                            visibility
                                          ) {
                                            return _vm.handleVisibleChange(
                                              visibility
                                            )
                                          },
                                          itemSelected: _vm.openScheduleEmail
                                        }
                                      },
                                      [
                                        _c("CompassDropdownOption", {
                                          attrs: {
                                            label: _vm.$t.__(
                                              "email.ScheduleEmailDialog.title"
                                            ),
                                            value: "scheduleAction",
                                            icon: "calendar-reschedule",
                                            isCheckable: false
                                          },
                                          on: { click: _vm.openScheduleEmail }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("ScheduleEmailDialog", {
                                      attrs: {
                                        visible: _vm.showScheduleEmailDialog
                                      },
                                      on: {
                                        scheduled: _vm.handleSendScheduledEmail,
                                        close: function($event) {
                                          _vm.showScheduleEmailDialog = false
                                        }
                                      }
                                    })
                                  ]
                                : _c(
                                    "CompassTooltip",
                                    {
                                      attrs: {
                                        disabled: _vm.canSendEmail,
                                        content: _vm.$t.__(
                                          "email.EmailPanel.error_reconnect_email_account"
                                        ),
                                        placement: "top-end"
                                      }
                                    },
                                    [
                                      _c("CompassButton", {
                                        attrs: {
                                          label: _vm.$t.__(
                                            "common.actions.send"
                                          ),
                                          loading: _vm.isLoading,
                                          disabled: !_vm.canSendEmail
                                        },
                                        on: { click: _vm.onSendEmail }
                                      })
                                    ],
                                    1
                                  )
                            ],
                            2
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showPanel,
            callback: function($$v) {
              _vm.showPanel = $$v
            },
            expression: "showPanel"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isPanelMinimized,
                  expression: "!isPanelMinimized"
                }
              ],
              staticClass: "email-panel__content"
            },
            [
              _c("EmailRecipientsInputs", {
                staticClass: "email-recipients-inputs",
                attrs: {
                  hashPanel: _vm.hashPanel,
                  recipients: _vm.recipients,
                  isUpdatingRecipients: _vm.isUpdatingRecipients
                },
                on: {
                  updateAddressesEmails: _vm.onUpdateAddressesEmails,
                  updateRecipient: function($event) {
                    _vm.isUpdatingRecipients = false
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "email-panel__content-subject" },
                [
                  _c("EmailSubjectInput", {
                    attrs: { subject: _vm.email.subject },
                    on: {
                      "update:subject": function(newSubject) {
                        _vm.email.subject = newSubject
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.activeLinked.name
                ? _c("EmailRelatedObject", {
                    attrs: { object: _vm.activeLinked }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("RichText", {
                ref: "refEmailPanelRichText",
                staticClass: "email-richtext",
                attrs: {
                  options: _vm.optionsRichText,
                  isCustom: true,
                  showRichTextMenu: false,
                  showAIComponents: _vm.isSellsyAIEnabled,
                  typeRichText: "email",
                  hash: _vm.hashPanel
                },
                on: {
                  focus: function($event) {
                    _vm.isEditorFocused = true
                  },
                  blur: function($event) {
                    _vm.isEditorFocused = false
                  }
                },
                scopedSlots: _vm._u(
                  [
                    _vm.isDragging
                      ? {
                          key: "drag-handle",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "drag-text typographies-paragraph-large-bold",
                                  on: {
                                    dragleave: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleDragLeave($event)
                                    },
                                    drop: function($event) {
                                      $event.preventDefault()
                                      return _vm.handleDrop($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.labelDrag) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.email.content,
                  callback: function($$v) {
                    _vm.$set(_vm.email, "content", $$v)
                  },
                  expression: "email.content"
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.attachments, function(item, index) {
                return [
                  _vm.attachments.length
                    ? _c("EmailAttachments", {
                        key: index,
                        attrs: { attachment: item },
                        on: { removeItem: _vm.removeAttachment }
                      })
                    : _vm._e()
                ]
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.shouldDisplayErrorDialog,
            size: "small",
            title: _vm.$t.__("email.emailPanels.EmailPanel.error"),
            primaryAction: _vm.primaryAction,
            secondaryActions: _vm.secondaryActions
          },
          on: {
            "update:visible": function($event) {
              _vm.shouldDisplayErrorDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.textDialogError) + "\n        "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            visible: _vm.shouldDisplayEmptyRecipientsWarningDialog,
            title: _vm.$t.__(
              "email.emailPanels.EmailPanel.empty_recipients_warning_dialog.title"
            ),
            size: "small",
            primaryAction: _vm.primaryActionEmptyRecipientsWarningDialog,
            secondaryActions: _vm.secondaryActionsEmptyRecipientsWarningDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.shouldDisplayEmptyRecipientsWarningDialog = $event
            }
          }
        },
        [
          _c("p", {
            staticClass: "typographies-paragraph-medium-regular",
            domProps: {
              innerHTML: _vm._s(_vm.emptyRecipientsWarningDialogText)
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }